/** Die Auswahl an Symbolen für Bereiche (D-00c, BE-06): Name -> Lucide-Symbol. */
import {
  BookOpen, Briefcase, Camera, Car, Coffee, Dumbbell, Gamepad2, GraduationCap, HeartPulse, Home, Layers, Leaf, Music, Palette, PawPrint, Plane, Sparkles, Users, Wallet, Wrench,
  type LucideIcon,
} from 'lucide-react';

export const BEREICHS_SYMBOLE: Record<string, LucideIcon> = {
  'heart-pulse': HeartPulse, 'graduation-cap': GraduationCap, wallet: Wallet, briefcase: Briefcase, home: Home,
  'book-open': BookOpen, palette: Palette, music: Music, plane: Plane, users: Users, sparkles: Sparkles, dumbbell: Dumbbell,
  camera: Camera, car: Car, coffee: Coffee, gamepad: Gamepad2, leaf: Leaf, paw: PawPrint, wrench: Wrench, layers: Layers,
};

export const BEREICHS_SYMBOL_NAMEN = Object.keys(BEREICHS_SYMBOLE);
